/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Lifeskill } from '../../models/lifeskill';

export interface PostLifeskill$Plain$Params {
  'api-version'?: string;
  
    /**
     * Lifeskill to create
     */
    body?: Lifeskill
}

export function postLifeskill$Plain(http: HttpClient, rootUrl: string, params?: PostLifeskill$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Lifeskill>> {
  const rb = new RequestBuilder(rootUrl, postLifeskill$Plain.PATH, 'post');
  if (params) {
    rb.query('api-version', params['api-version'], {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Lifeskill>;
    })
  );
}

postLifeskill$Plain.PATH = '/lifeskill';
